import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import KayitIstatistikleri from './KayitIstatistikleri';
import { motion } from 'framer-motion';
import OdemelerRaporu from './OdemelerRaporu';

const DashboardPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box sx={{ my: 4 }}>
          <KayitIstatistikleri />
          <OdemelerRaporu />

          {/* Diğer dashboard bileşenleri */}
        </Box>
      </motion.div>
    </Container>
  );
};

export default DashboardPage;